/**
 * TiTiler — defaults per raster_type. Used when no user/station style is set.
 * @see ./titilerTileUrl.js for how these are applied to tile requests.
 */

const DEFAULTS_BY_TYPE = Object.freeze({
  snow_depth: { colormapName: 'elda_snow_mnt', rescaleMode: 'auto', renderMode: 'default' },
  dtm: { colormapName: 'gray', rescaleMode: 'auto', renderMode: 'default' },
  dsm: { colormapName: 'gray', rescaleMode: 'auto', renderMode: 'default' },
  ortho_rgb: { colormapName: null, rescaleMode: null, renderMode: 'default' },
  ortho_ir: { colormapName: 'viridis', rescaleMode: 'auto', renderMode: 'default' },
  custom: { colormapName: 'viridis', rescaleMode: 'auto', renderMode: 'default' },
})

/**
 * Returns the TiTiler default style for a given raster_type. Falls back to `custom` if unknown.
 * @param {string} rasterType
 * @returns {{ colormapName: string|null, rescaleMode: string|null, renderMode: string }}
 */
export function getTitilerDefaultsForRasterType(rasterType) {
  return DEFAULTS_BY_TYPE[rasterType] || DEFAULTS_BY_TYPE.custom
}

/**
 * Detect ortho_rgb layers (TiTiler should NOT inject colormap or rescale for these).
 * @param {{raster_type?: string} | null | undefined} layer
 * @returns {boolean}
 */
export function isOrthoRgbRaster(layer) {
  return layer?.raster_type === 'ortho_rgb'
}
